import { useState, useEffect } from 'react';
import { ACSApi } from '../../../api';
import { TeamWithTeamLeadDto } from '../../../commonTypes/acs';
import { useContainer } from '../../useContainer';

const useHttpGetUsersTeams = (userSub: string) => {
    const ascApi: ACSApi = useContainer(ACSApi);

    const [teams, setTeams] = useState<TeamWithTeamLeadDto[]>([]);
    const [isReady, setIsReady] = useState(false);

    const getTeams = () => {
        const { exec, abort } = ascApi.getProfileUsersTeams({
            params: { userSub },
            onSuccess: res => setTeams(res.body),
            onFinally: () => setIsReady(true),
        });

        exec();
        return abort;
    };

    useEffect(() => {
        getTeams();
    }, []);

    return { teams, setTeams, isReady };
};

export default useHttpGetUsersTeams;
